import Link, { type LinkProps as NextLinkProps } from 'next/link';
import { forwardRef, type AnchorHTMLAttributes, type ReactNode } from 'react';

type LinkProps = NextLinkProps &
  Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof NextLinkProps> & {
  children?: ReactNode
}

// eslint-disable-next-line react/display-name
const LinkNoPrefetch = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, ...props }, ref) => {
    return (
      <Link prefetch={false} {...props} ref={ref}>
        {children}
      </Link>
    );
  }
);

export default LinkNoPrefetch;
